import React, { InputHTMLAttributes, useEffect, useRef, useState } from "react"
import cn from "classnames"
import EyeButton from "./EyeButton"
import { t } from "../../i18n"

interface InputProps {
  className?: string;
  hasHeader?: boolean;
  hasLabel?: boolean;
  i18key?: string;
  isError?: boolean;
  input: InputHTMLAttributes<HTMLInputElement>;
  label?: string;
  labelClassName?: string;
  small?: boolean;
  tightLabel?: boolean;
  unit?: string;
}

const Input: React.FC<InputProps> = (props: InputProps) => {
  const { i18key, input, label, unit, hasLabel = true } = props;
  const inputElement = useRef<HTMLInputElement>(null);

  const [passwordVisible, setPasswordVisible] = useState<boolean>(false)

  if (input.type === "number") {
    /* Move useEffect out of `if` if (type === "number") can change during the lifecycle */
    useEffect(() => {
      if (input.value === "" && inputElement?.current) {
        inputElement.current.value = "";
      }
    })
  }

  const className = cn("Input", props.className, {
    "Input--error": props.isError,
    "Input--filled": input.value || input.value === 0 || input.type === "date",
    "Input--disabled": input.disabled,
    "Input--small": props.small,
    "Input--tightLabel": props.tightLabel,
    "Input--withUnit": props.unit,
    "Input--visiblePassword": passwordVisible,
  })

  const togglePassword = () => {
    setPasswordVisible(!passwordVisible)
  }

  const originalType = input.type
  const actualType = passwordVisible ? "text" : originalType

  return (
    <label className={className}>
      {props.hasHeader && <span className="text-xs mt-4 text-rolling-stone">{t(i18key)}</span>}
      <input {...input} className="Input-input" ref={inputElement} type={actualType}/>
      {!props.hasHeader && hasLabel && <span className={cn("Input-label", props.labelClassName)}>{label || t(i18key)}</span>}
      {unit && <span className="Input-unit">{unit}</span>}
      {originalType === "password" && <EyeButton className="Input-eyeButton" onClick={togglePassword} tabIndex={-1}/>}
    </label>
  )
}

export default Input
